import React from 'react';

import { Typography } from 'antd';

interface IProps {
  value?: string | null;
}

export const TableCellEllipsisText: React.FC<IProps> = ({ value }) => {
  const text = value || '-';

  return (
    <Typography.Text ellipsis={{ tooltip: text }} style={{ display: 'block', width: '100%' }}>
      {text}
    </Typography.Text>
  );
};
